module.exports = __webpack_public_path__ + "static/img/combinedValbe-p.3479ada.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/combinedValbe-p.png
// module id = 1Amj
// module chunks = 1